import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { AppComponent } from "./app.component";
import { SidebarComponent } from "./inside-of-application/sidebar/sidebar.component";
import { CommonModule, APP_BASE_HREF } from "@angular/common";
import { AppRoutingModule } from "./app-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  withJsonpSupport,
} from "@angular/common/http";
//import { HashLocationStrategy, LocationStrategy } from "@angular/common";
// import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
// import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
// import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { LoginComponent } from "./out-of-application/login/login.component";
import { LogoutComponent } from "./out-of-application/logout/logout.component";
import { PageNotFoundComponent } from "./out-of-application/page-not-found/page-not-found.component";
import { SessionExpiredComponent } from "./out-of-application/session-expired/session-expired.component";
import { UnAuthorizeComponent } from "./out-of-application/un-authorize/un-authorize.component";
import { BadRequestComponent } from "./out-of-application/bad-request/bad-request.component";
import { ProgressComponent } from "./out-of-application/progress/progress.component";
import { DashboardComponent } from "./inside-of-application/dashboard/dashboard.component";
import { AuthGuardService } from "./Common/auth-guard.service";
import {
  AppTokenHandler,
  HTTPStatus,
  UserInfo,
} from "./Common/app-token-handler";
import { ErrorHandler } from "@angular/core";
import { AppErrorHandler } from "./Common/app-error-handler";
import { WinAuthInterceptor } from "./Common/interceptor";
import { DataService, UIBlockingStatus } from "./Common/data.service";
// import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";
import { HomeComponent } from "./inside-of-application/home/home.component";
import { AutoCompleteModule } from "primeng/autocomplete";
import { BlockUIModule } from "primeng/blockui";
import { ToastModule } from "primeng/toast";
import { MessageService } from "primeng/api";
import { DropdownModule } from "primeng/dropdown";
import { MultiSelectModule } from "primeng/multiselect";
import { MessageModule } from "primeng/message";
import { TableModule } from "primeng/table";
import { Global } from "src/app/Global";
//import { RichTextEditorModule } from "@syncfusion/ej2-angular-richtexteditor";
// import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
// import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
// import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import {
  MatNativeDateModule,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  DateAdapter,
} from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
// import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { MatIconModule } from "@angular/material/icon";
// import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
// import { MatLegacyListModule as MatListModule } from "@angular/material/legacy-list";
// import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
// import { MatLegacyPaginatorModule as MatPaginatorModule } from "@angular/material/legacy-paginator";
// import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
// import { MatLegacyRadioModule as MatRadioModule } from "@angular/material/legacy-radio";
// import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { MatSidenavModule } from "@angular/material/sidenav";
// import { MatLegacySlideToggleModule as MatSlideToggleModule } from "@angular/material/legacy-slide-toggle";
// import { MatLegacySliderModule as MatSliderModule } from "@angular/material/legacy-slider";
import { MatSortModule } from "@angular/material/sort";
// import { MatLegacyTableModule as MatTableModule } from "@angular/material/legacy-table";
// import { MatLegacyTabsModule as MatTabsModule } from "@angular/material/legacy-tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
// import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { CreateServiceRequestComponent } from "./inside-of-application/create-service-request/create-service-request.component";
import { ServiceRequestComponent } from "./inside-of-application/service-request/service-request.component";
import { HeaderMainComponent } from "./inside-of-application/header-main/header-main.component";
import { CategoryMasterComponent } from "./inside-of-application/category-master/category-master.component";
import { SubCategoryComponent } from "./inside-of-application/sub-category/sub-category.component";
import { ViewServiceRequestComponent } from "./inside-of-application/Views/view-service-request/view-service-request.component";
import { FileUploadComponent } from "./out-of-application/file-upload/file-upload.component";
import { MailTemplateComponent } from "./out-of-application/mail-template/mail-template.component";
import { ItemMasterComponent } from "./inside-of-application/item-master/item-master.component";
import { AssigmentGroupComponent } from "./inside-of-application/assigment-group/assigment-group.component";
import { MappingGroupItemComponent } from "./inside-of-application/mapping-group-item/mapping-group-item.component";
import { EscalationSequenceComponent } from "./inside-of-application/escalation-sequence/escalation-sequence.component";
import { AdminBarChartComponent } from "./inside-of-application/admin-bar-chart/admin-bar-chart.component";
import { SearchViewComponent } from "./out-of-application/search-view/search-view.component";
import { AlertComponent } from "./out-of-application/alert/alert.component";
import { ViewmyservicerequestComponent } from "./inside-of-application/Views/viewmyservicerequest/viewmyservicerequest.component";
import { MyServiceRequestComponent } from "./inside-of-application/my-service-request/my-service-request.component";
import { CharachterDirective } from "./Directive/CharOnly";
import { DecimalDirective } from "./Directive/DecimalOnly";
import { NumberDirective } from "./Directive/NumbersOnly";
import { AlphanumericDirective } from "./Directive/AlphaNumeric";
import { CompleteReportComponent } from "./inside-of-application/Reports/complete-report/complete-report.component";
import { AssignmentUploadComponent } from "./inside-of-application/assignment-upload/assignment-upload.component";
import { ViewUploadComponent } from "./inside-of-application/view-upload/view-upload.component";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
//import { HttpClientModule } from "node_modules1/@angular/common/http";
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
// import { MomentDateAdapter } from '@angular/material-moment-adapter';
// import { ItemMasterComponent } from './inside-of-application/item-master/item-master.component';
// import { AssigmentGroupComponent } from './inside-of-application/assigment-group/assigment-group.component';
// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   suppressScrollX: true,
// };
import { MatExpansionModule } from '@angular/material/expansion';
import { CdkAccordionModule } from '@angular/cdk/accordion';
//import { NgxSpinnerModule } from 'ngx-spinner';
//import { PreLoaderComponent } from './out-of-application/pre-loader/pre-loader.component';
// import { ChartsModule } from "node_modules1/ng2-charts/public_api";
// import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { BaseChartDirective } from 'ng2-charts';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { AppInsightsService } from "./Common/app-insights.service";
import { NgxEditorModule } from "ngx-editor";
import { LoginService } from "./Common/login.service";
//import { NgChartsModule } from 'ng2-charts';

export const Cust_Date_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: "YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "YYYY",
  },
};

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    BadRequestComponent,
    PageNotFoundComponent,
    LogoutComponent,
    UnAuthorizeComponent,
    SessionExpiredComponent,
    LoginComponent,
    ProgressComponent,
    AppComponent,
    SidebarComponent,
    LoginComponent,
    LogoutComponent,
    PageNotFoundComponent,
    SessionExpiredComponent,
    UnAuthorizeComponent,
    BadRequestComponent,
    ProgressComponent,
    DashboardComponent,
    HomeComponent,
    CreateServiceRequestComponent,
    ServiceRequestComponent,
    HeaderMainComponent,
    CategoryMasterComponent,
    SubCategoryComponent,
    ViewServiceRequestComponent,
    FileUploadComponent,
    MailTemplateComponent,
    ItemMasterComponent,
    AssigmentGroupComponent,
    MappingGroupItemComponent,
    EscalationSequenceComponent,
    AdminBarChartComponent,
    SearchViewComponent,
    AlertComponent,
    ViewmyservicerequestComponent,
    MyServiceRequestComponent,
    NumberDirective,
    DecimalDirective,
    CharachterDirective,
    AlphanumericDirective,
    CompleteReportComponent,
    AssignmentUploadComponent,
    ViewUploadComponent,
    //PreLoaderComponent,
    // ItemMasterComponent,
    // AssigmentGroupComponent
  ],
  exports: [NumberDirective, DecimalDirective, CharachterDirective],
  bootstrap: [AppComponent],
  imports: [
    // HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    MatInputModule,
    MatRadioModule,
    // MatIconModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    ToastModule,
    MatCardModule,
    MatButtonModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSortModule,
    MatDialogModule,
    AutoCompleteModule,
    DropdownModule,
    BlockUIModule,
    MessageModule,
    BlockUIModule,
    FormsModule,
    BsDropdownModule.forRoot(),
    // PerfectScrollbarModule,
    MultiSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSidenavModule,
    MatToolbarModule,
    // MatMenuModule,
    MatListModule,
    // Ng4LoadingSpinnerModule.forRoot(),
    TableModule,
    //RichTextEditorModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatMenuModule,
    MatExpansionModule,
    CdkAccordionModule,
    //NgxSpinnerModule
    NgxEditorModule
  ],
  providers: [
    DataService,
    AppTokenHandler,
    HTTPStatus,
    AuthGuardService,
    UIBlockingStatus,
    AppErrorHandler,
    UserInfo,
    MessageService,
    AppInsightsService,
    Global,
    LoginService,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: WinAuthInterceptor,
    //   multi: true,
    //   // useValue: "/",
    // },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    //{ provide: LocationStrategy, useClass: HashLocationStrategy },
    // {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    // { provide: MAT_DATE_FORMATS, useValue: Cust_Date_FORMATS },
    // { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    // {
    //   provide: PERFECT_SCROLLBAR_CONFIG,
    //   useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    // },
    // provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    // provideHttpClient()
    // provideCharts(withDefaultRegisterables()),
    provideHttpClient(withInterceptors([WinAuthInterceptor])),
    provideAnimationsAsync(),
    provideCharts(withDefaultRegisterables())

  ],
})
export class AppModule { }

